import React from "react";
import { Check } from "../../icons/check";

interface CheckBoxProps {
  checked: boolean;
  setChecked: (checked: boolean) => void;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const CheckBox: React.FC<CheckBoxProps> = ({
  checked,
  setChecked,
  onClick,
}) => {
  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    setChecked(!checked);
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      type="button" // Prevent form submission
      onClick={handleClick}
      className={`h-5 w-5 flex-shrink-0 flex flex-col items-center justify-center border dark:border-neutral-600 rounded-md ${
        checked
          ? "bg-black border-black dark:bg-white dark:border-white"
          : "hover:bg-neutral-100 dark:hover:bg-neutral-800 border-neutral-300"
      }`}
    >
      {checked ? <Check className="text-white dark:text-black" /> : null}
    </button>
  );
};

export default CheckBox;
